import { abbreviateNumber } from 'js-abbreviation-number'

export const formatNumber = (value?: number | string | null) => {
  if (!value) {
    return '0'
  }

  if (isNaN(Number(value))) {
    return value
  }

  return abbreviateNumber(Number(value))
}

export const formatNumberComma = (value?: number | null) => {
  if (!value) {
    return '0'
  }

  return new Intl.NumberFormat('en').format(value)
}
